import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT, IDLE, PENDING } from "const"
import {
    StateType,
    hasAccess,
    forceRerenderContent,
    deepCopy,
} from "client/utils"
import {
    PRM_PROJECT,
    StoreType,
    ProjectProps,
    ProjectSettings,
    LoadAccountSettings,
    LoadProjectSettings,
    SaveProjectSettings,
    setProjectProjectSettings,
    setSilAssumptionReloadView,
    closeModal,
} from "client/store"

import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    PageForm,
    FormGroup,
    CKEditor,
    Button,
    SpinnerIcon,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"

let isMounted: boolean

const AssumptionEdit = ({
    projectId = null,
}: ProjectProps) => {
    const baseRoute = useSelector((state: StoreType) => state.silAssumption.baseRoute)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [assumption, setAssumption] = useState("")

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        setLoadState(PENDING)

        LoadAccountSettings(userData.accountId)
        .then((res1) => {
            LoadProjectSettings(projectId)
            .then((res2) => {
                if (res2.sil.assumption) setAssumption(res2.sil.assumption)
                else if (res1.sil.defaultAssumption) setAssumption(res1.sil.defaultAssumption)
                else setAssumption("")
                setLoadState(IDLE)
            })
        })

        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (!isMounted) return
        if (modals.length) {
            if (isMounted) dispatch(closeModal())
            return
        }
        forceRerenderContent(baseRoute, dispatch)
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newProjectSettings: ProjectSettings = deepCopy(projectSettings)
        newProjectSettings.sil.assumption = assumption

        SaveProjectSettings(projectId, newProjectSettings)
        .then(() => {
            dispatch(setProjectProjectSettings(newProjectSettings))

            if (isMounted) {
                setSaveState(IDLE)
                setApplyState(IDLE)
            }

            dispatch(setSilAssumptionReloadView(false))
            setTimeout(() => {
                dispatch(setSilAssumptionReloadView(true))
            }, 0)

            if (mode === 1) onClose()
        })
    }


    const editAccess = hasAccess(PRM_PROJECT, EDIT)
    const allowedToEdit = editAccess || project.owner === userData.userId

    if (!allowedToEdit) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editCalculationAssumptions}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <CKEditor
                                    data={assumption}
                                    onChange={setAssumption}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button
                                variant="success"
                                row
                                onClick={() => onSave(1)}
                            >
                                {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                            </Button>
                            <Button
                                variant="success"
                                row
                                onClick={() => onSave(2)}
                            >
                                {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                            </Button>
                            <Button row onClick={onClose}>{lang.cancel}</Button>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default AssumptionEdit
